/**
 * Frase italiana fissa per un errore nella lettura della configurazione di WhatsApp.
 *
 * useApiConfig restituisce testi tecnici ("WhatsApp configuration error: ...",
 * "Failed to load API configuration", "User not authenticated or missing
 * organization"): all'utente si mostra una frase semplice, il dettaglio resta in console.
 * Modulo puro, testato in __tests__/configErrorText.test.ts.
 */
export function configErrorText(raw: unknown): string {
  const t = (typeof raw === 'string' ? raw : raw instanceof Error ? raw.message : '').toLowerCase();
  if (t.includes('not authenticated') || t.includes('missing organization')) {
    return "Non riesco a riconoscere il tuo accesso: esci e rientra nel CRM, poi riprova.";
  }
  if (t.includes('non trovata') || t.includes('not found')) {
    return 'Non trovo la configurazione di questo numero WhatsApp. Controlla il numero in Impostazioni > WhatsApp.';
  }
  return 'Non riesco a leggere la configurazione di WhatsApp. Riprova tra poco. Se il problema resta, controlla il numero in Impostazioni > WhatsApp.';
}
